import type { FC } from 'react';

import type { Company } from '@xing-com/crate-common-graphql-types';
import { SkeletonCard } from '@xing-com/skeleton';

import { SimpleCompanyCard } from '../simple-company-card/simple-company-card';

type TopCompanyCardSubcomponents = {
  Skeleton: any;
};

type TopCompanyCardProps = {
  company: Company;
};
// This component is temporaly as we will develop a TopCompanyCard in another task
export const TopCompanyCard: FC<TopCompanyCardProps> &
  TopCompanyCardSubcomponents = ({ company }) => {
  return (
    <SimpleCompanyCard
      item={{
        id: company.id,
        name: company.companyName ?? ' ',
        companyUrl: company.links?.public ?? '',
        location: company.address?.city ?? '',
        industry: company.industry?.localizationValue,
        kununuRatting: 23,
        profileImageUri: company.logos?.logo128px ?? '',
        hasOpenJobs: true,
      }}
    />
  );
};

TopCompanyCard.Skeleton = SkeletonCard;
